import React from 'react'

import { Box, Skeleton, Tooltip, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'

const multiNoWrap = lines => {
  return {
    lineClamp: lines,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical'
  }
}

export const useStyles = makeStyles(
  ({ palette, typography, spacing, breakpoints, props }) => ({
    skillBuilderInfo: {
      display: 'flex',
      flex: 1
    },
    skillBuilderInfoBorder: {
      borderLeft: `5px solid ${palette.grey.shade[5]}`,
      paddingLeft: spacing(1)
    },
    skillBuilderName: {
      ...typography.heading.h4,
      ...multiNoWrap(3),
      lineHeight: 1.1,
      marginBottom: spacing(1)
    },
    skillBuilderDescription: { ...typography.body.s, ...multiNoWrap(3) },
    skillBuilderInfoLoadingContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      alignItems: 'center'
    },
    skillBuilderInfoLoading: {
      flex: 1,
      paddingLeft: spacing(1)
    }
  })
)

export const SkillBuilderCardInfoContainer = ({ isLoading, name, description }) => {
  const classes = useStyles()

  function renderName () {
    return (
      <Typography className={classes.skillBuilderName}>
        {isLoading ? <Skeleton width={150} /> : name}
      </Typography>
    )
  }

  if (isLoading) {
    return (
      <Box className={classes.skillBuilderInfoLoadingContainer}>
        <Box style={{ height: '100%' }}>
          <Skeleton
            height='100%'
            width='6px'
          />
        </Box>
        <Box className={classes.skillBuilderInfoLoading}>
          {renderName()}
          <Typography className={classes.skillBuilderDescription}>
            <Box>
              <Skeleton width='100%' />
              <Skeleton width='85%' />
            </Box>
          </Typography>
        </Box>
      </Box>
    )
  }

  return (
    <Box className={classes.skillBuilderInfo}>
      <Box className={classes.skillBuilderInfoBorder}>
        <Box className={classes.skillBuilderName} data-test={`skill-builder-card-name-${name}`}>
          {renderName()}
        </Box>
        <Tooltip title={description} aria-label={description} placement='top' data-test={`skill-builder-card-description-${name}`}>
          <Typography className={classes.skillBuilderDescription}>
            {description}
          </Typography>
        </Tooltip>
      </Box>
    </Box>
  )
}
